import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertUnixTimeToUtcString'
})
export class ConvertUnixTimeToUtcStringPipe implements PipeTransform {

  transform(value: number): string {
    return new Date(value).toUTCString();
  }
}
